import styled from 'styled-components';
import { SuiTextInput, SuiDropdown } from '@splashthat/sui';

export const DurationContainer = styled.div`
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5em;
`;

export const DurationInputText = styled(SuiTextInput)`
    min-width: 3rem;
    width: 3rem;
`;

export const DurationDropdown = styled(SuiDropdown)`
    min-width: 5rem;
`;
